import SuperRepository from '../superRepository'

export default new (class PlayersReportsRepository extends SuperRepository {
  baseUri() {
    return 'report'
  }
  getFile = async ({id, field}) =>
  this.httpClient().getFile(`${this.baseUri()}/get_file/${id}`, {field})
  getParseData = async ({id, field}) =>
  this.httpClient().getFile(`report_retry_history/${id}/get_parse_data`, {field})
  retry = async (id) => this.httpClient().post(`${this.baseUri()}/${id}/re_import`)
  retryHistory = async (reportId) => this.httpClient().get(`report_retry_history`, { filter: { report: { id: reportId } } })
})()